import GifCategoryItem from '@shared/Features/MobileLandingGifsSection/GifCategoryItem/GifCategoryItem';
import MobileCarousel from '@shared/Ui/MobileCarousel/MobileCarousel';
import { MobileLandingGifItem } from '@modules/Landing/Shared/Interfaces/MobileLandingGifItem';
import { useEffect, useState } from 'react';

export const MobileLandingGifsSectionCategories: MobileLandingGifItem[] = [
    {
        gif: () =>
            import('@assets/Imgs/LandingMobileGifs/chooseTemplateMobile.gif'),
    },
    {
        gif: () =>
            import(
                '@assets/Imgs/LandingMobileGifs/enterYourMeasurementsMobile.gif'
            ),
    },
    {
        gif: () =>
            import(
                '@assets/Imgs/LandingMobileGifs/getYourBillOfMaterialsMobile.gif'
            ),
    },
    {
        gif: () =>
            import('@assets/Imgs/LandingMobileGifs/refineYourListMobile.gif'),
    },
    {
        gif: () =>
            import('@assets/Imgs/LandingMobileGifs/downloadOrBuyMobile.gif'),
    },
];

export const MobileLandingGifsSection: React.FC = () => {
    const [gifUrls, setGifUrls] = useState<string[]>([]);

    useEffect(() => {
        const loadGifs = async () => {
            const urls = await Promise.all(
                MobileLandingGifsSectionCategories.map(async item => {
                    const module = await item.gif();
                    return module.default;
                })
            );
            setGifUrls(urls);
        };
        loadGifs();
    }, []);

    const carouselItems = MobileLandingGifsSectionCategories.map((_, index) => (
        <GifCategoryItem key={index} gif={gifUrls[index] || ''} />
    ));
    return <MobileCarousel items={carouselItems} />;
};
